import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';

export interface Offer { priceOre: number; currency: string; }
export interface PurchaseStatus {
  status: 'CREATED' | 'PAID' | 'FAILED';
  downloadPath?: string;
  sentTo?: string;
}
export interface DownloadInfo {
  status: 'READY' | 'USED' | 'EXPIRED' | 'NOT_FOUND';
  assetId?: string;
}

@Injectable({ providedIn: 'root' })
export class PurchaseService {
  private http = inject(HttpClient);

  getOffer() {
    return this.http.get<Offer>( environment.apiBaseCommerceUrl + '/api/offer');
  }

  start(assetId: string, contact: { email?: string; phone?: string }) {
    return this.http.post<{ redirectUrl: string }>( environment.apiBaseCommerceUrl + '/api/purchases', { assetId, ...contact });
  }

  status(reference: string) {
    return this.http.get<PurchaseStatus>( environment.apiBaseCommerceUrl + `/api/purchases/${encodeURIComponent(reference)}` );
  }

  download(token: string) {
    return this.http.get<DownloadInfo>( environment.apiBaseCommerceUrl + `/api/downloads/${encodeURIComponent(token)}` );
  }
}
